export default __webpack_public_path__ + "static/media/15Dimic.82ea3a5b.jpg";